__turbopack_context__.v({
  "container": "UyXV4q_container",
});
